import { toast } from "react-toastify";
import { handleApiError } from "../../../services/errorTranslator";
import { USER_PREFERENCES_KEY, userPreferencesStorage } from "../service/userPreferenceStorageService";
import { useSaveUserPreferenceMutation } from "../../../services/API/commonApiSlice";
import { UserPreferenceRequest } from "../models/UserPreferenceRequest";
/**
* Saves the user preferences to the backend if they have changed.
* 
* Can be called from anywhere: route change, logout, button click, etc.
*/
export const useSaveUserPreferencesIfChanged = () => {
    const [saveUserPreferenceMutation] = useSaveUserPreferenceMutation();

    const saveIfChanged = async () => {
        if (!userPreferencesStorage.isUserPreferenceChanged()) return;

        const payload: UserPreferenceRequest = {
            preferences: JSON.parse(
                sessionStorage.getItem(USER_PREFERENCES_KEY) ?? "{}"
            ),
        };

        try {
        const result = await saveUserPreferenceMutation(payload).unwrap();

        if (result && result.preferences && result.lastUpdated) {
            userPreferencesStorage.clear();
            userPreferencesStorage.setAll(JSON.stringify(result.preferences));
            toast.success("User Preferences successfully saved");
        }
        } catch (error) {
            handleApiError(error);
        }
    };

    return saveIfChanged;
};
